const zooms = [
  { id: "1", name: "100%" },
  { id: "0.95", name: "95%" },
  { id: "0.9", name: "90%" },
  { id: "0.85", name: "85%" },
  { id: "0.8", name: "80%" },
  { id: "0.75", name: "75%" },
  { id: "0.7", name: "70%" },
  { id: "0.65", name: "65%" },
  { id: "0.6", name: "60%" },
];

export { zooms };
